// src/hooks/useLanguage.ts
import { useTranslation } from "@/i18n/i18n";
import type { SupportedLanguage } from "@/lib/legal-content";

/**
 * Hook for type-safe language detection.
 * Now delegates to the i18n provider for consistent locale across the app.
 * Returns validated language, never throws.
 */
export function useLanguage(): SupportedLanguage {
  const { locale } = useTranslation();
  return locale;
}
